import { MainView, Button, SubBar, FormControl } from "lib/index";
import React from "react";
import styles from "./StepIntegrations.less"
import CSSModules from "lib/utils/css-modules"
import { initializeView } from "./index"
import { connect } from "react-redux";
import { stateSelector } from "../index";
import ApiConnectlyService from "lib/services/ApiConnectlyService";
import IntegrationLogRow from "./IntegrationLogRow";
import IntegrationLogDetails from "./IntegrationLogDetails";
const columns = [
    'papp.products.EditProductView.StepIntegrations.log_integration_action',
    'papp.products.EditProductView.StepIntegrations.log_integration_uuid',
    'papp.products.EditProductView.StepIntegrations.log_integration_date'
]

@connect(
    state => ({
        product: stateSelector(state).initialProduct,
    })
)
@CSSModules(styles)
export default class StepIntegrations extends React.PureComponent {
    constructor(props) {
        super(props);
        this.state = {
            integrations: {
                autoUpdateCalendar: null,
                autoUpdateDestination: null,
                autoUpdateImages: null,
                autoUpdatePrices: null,
                productId: null
            },
            loading: false,
            error: null,
            choosenIntegrationLogId: null,
            logs: [],
            page: 1,
            pageSize: 25,
            totalPages: null
        };
    }

    getIntegrationUpdateStatuses() {
        const { product } = this.props
        ApiConnectlyService.getIntegrationUpdateInfo(Number(product.id))
            .then(response => {
                this.setState({
                    integrations: response.data,
                    loading: false,
                    error: null
                });
            })
            .catch(error => {
                this.setState({
                    integrations: [],
                    loading: false,
                    error: error.message
                });
            });
    }

    getIntegrationLogs() {
        const { product } = this.props
        const { page, pageSize } = this.state
        ApiConnectlyService.getIntegrationLogs({
            pageNumber: Number(page),
            pageSize: Number(pageSize),
            productId: Number(product.id)
        })
            .then(response => {
                this.setState({
                    logs: response.data,
                    loading: false,
                    error: null,
                    totalPages: !isNaN(Number(response.data.rowCount))
                        ? Math.ceil(Number(response.data.rowCount) / pageSize)
                        : 1
                });
            })
            .catch(error => {
                this.setState({
                    integrations: [],
                    loading: false,
                    error: error.message
                });
            });
    }


    handleChangeIntegrationUpdate = (type, checked) => {
        const { product } = this.props
        const { integrations } = this.state
        const data = {
            id: product.id,
            descriptionStatus: type === 'description' ? checked : integrations.autoUpdateDestination,
            imagesStatus: type === 'images' ? checked : integrations.autoUpdateImages,
            pricesStatus: type === 'prices' ? checked : integrations.autoUpdatePrices,
            calendarStatus: type === 'calendar' ? checked : integrations.autoUpdateCalendar
        };

        ApiConnectlyService.updateIntegrationUpdate(data)
            .then((response) => {
                this.getIntegrationUpdateStatuses(); // Use "this" to call the method within the class
            })
            .catch(error => {
                this.setState({
                    error: error.message
                });
            });
    }

    componentDidMount() {
        initializeView();
        this.getIntegrationUpdateStatuses();
        this.getIntegrationLogs();
    }

    componentDidUpdate(prevProps, prevState) {
        if (prevState.page !== this.state.page || prevState.pageSize !== this.state.pageSize) {
            this.getIntegrationLogs();
        }
    }

    render() {
        const { integrations, loading, error, choosenIntegrationLogId, pageSize, page, totalPages } = this.state;

        if (loading) {
            return <div>Loading...</div>;
        }

        if (error) {
            return <div>Error: {error}</div>;
        }
        const logs = () => {
            if (this.state.logs.list) {
                if (this.state.logs.list.length === 0) {
                    return <div style={{margin:'auto', textAlign:'center', fontSize:'18px'}}>Brak logów...</div>
                }
                return this.state.logs.list.map((integration) => {
                    return (
                        <IntegrationLogRow key={integration.id} data={integration} changeIntegrationLogId={() => this.setState({ choosenIntegrationLogId: integration.id })} />
                    )
                })
            }
        }
        const logDetails = () => {
            if (this.state.choosenIntegrationLogId) {
                return this.state.logs.list
                    .filter((integration) => integration.id === choosenIntegrationLogId)
                    .map((integration) => {
                        return <IntegrationLogDetails key={integration.id} {...integration} />
                    })
            }
        }
        const pageNumbers = Array.from(Array(totalPages).keys()).map(
            (_, index) => index + 1
        );

        const handlePageClick = (pageNumber) => {
            const { page } = this.props
            if (pageNumber !== page) {
                this.setState({ page: pageNumber })
            }
        };

        const handlePageSize = (event) => {
            if (pageSize !== event.target.value) {
                this.setState({ pageSize: event.target.value })
            }
        }

        return (
            <MainView.Container>
                <SubBar>
                    <div className="pull-left u-inlineFlexRow">
                        <h1>Integracje</h1>
                    </div>

                </SubBar>
                <MainView.Content grayBackground hasSidebar={false}>
                    <div styleName="section">
                        <div styleName="integration-update-toggle-button">
                            <FormControl.Checkbox
                                checked={integrations.autoUpdateDestination}
                                onChange={(checked) => this.handleChangeIntegrationUpdate('description', checked)}
                                label={I18n.humanAttributeName("product_integration", "auto_update_description")}
                                toggle
                                className="u-marginRight"
                            />
                        </div>
                        <div styleName="integration-update-toggle-button">
                            <FormControl.Checkbox
                                checked={integrations.autoUpdateImages}
                                onChange={(checked) => this.handleChangeIntegrationUpdate('images', checked)}
                                label={I18n.humanAttributeName("product_integration", "auto_update_images")}
                                toggle
                                className="u-marginRight"
                            />
                        </div>
                        <div styleName="integration-update-toggle-button">
                            <FormControl.Checkbox
                                checked={integrations.autoUpdatePrices}
                                onChange={(checked) => this.handleChangeIntegrationUpdate('prices', checked)}
                                label={I18n.humanAttributeName("product_integration", "auto_update_prices")}
                                toggle
                                className="u-marginRight"
                            />
                        </div>
                        <div styleName="integration-update-toggle-button">
                            <FormControl.Checkbox
                                checked={integrations.autoUpdateCalendar}
                                onChange={(checked) => this.handleChangeIntegrationUpdate('calendar', checked)}
                                label={I18n.humanAttributeName("product_integration", "auto_update_calendar")}
                                toggle
                                className="u-marginRight"
                            />
                        </div>
                    </div>
                    <div styleName='filter-buttons-group'>
                        <Button
                            as="a"
                            fluid
                            basic
                            content={I18n.t("papp.products.EditProductView.StepIntegrations.filter_all_logs")}
                        />
                        <Button
                            as="a"
                            fluid
                            basic
                            content={I18n.t("papp.products.EditProductView.StepIntegrations.filter_succeeded")}
                        />
                        <Button
                            as="a"
                            fluid
                            basic
                            content={I18n.t("papp.products.EditProductView.StepIntegrations.filter_all_failed")}
                        />
                    </div>
                    <div styleName="sort-buttons-group">
                        <div className="pull-left u-inlineFlexRow" style={{ marginRight: '3px' }}>
                            <FormControl.Input
                                value={null}
                                placeholder='Search...'
                            />
                        </div>
                        <Button
                            style={{ marginRight: '3px' }}
                            basic>
                            {/* <i className="icon material-icons" style={{fontSize:'20px'}}>event</i> */}
                            Date
                        </Button>
                        <Button
                            style={{ marginRight: '3px' }}
                            basic>
                            Status
                        </Button>
                        <Button
                            style={{ marginRight: '3px' }}
                            basic>
                            Method
                        </Button>
                        <Button
                            style={{ marginRight: '3px' }}
                            basic>
                            API endpoint
                        </Button>
                        <Button
                            style={{ marginRight: '3px' }}
                            basic>
                            More...
                        </Button>
                    </div>
                    <div styleName='logs-container'>
                        <div styleName="logs-list-container">
                            <div styleName='logs-list'>
                                <table styleName="logs-list-content">
                                    <thead>
                                        <tr>
                                            <th styleName='log-header-cell'>ID</th>
                                            {columns.map(column => <th key={column} styleName='log-header-cell'>{I18n.t(column)}</th>)}
                                        </tr>
                                    </thead>
                                    <tbody>
                                        {logs()}
                                    </tbody>
                                </table>
                            </div>
                            {this.state.logs !== undefined && this.state.logs.list !== undefined && this.state.logs.list.length > 0 && <div styleName="pagination-container">
                                <div styleName="page-size-container">
                                    <div styleName="page-size-label">ilość:</div>
                                    <select styleName="page-size-select" value={Number(pageSize)} onChange={handlePageSize}>
                                        {[10, 25, 50, 100, 200].map((option) => (
                                            <option key={option} value={option}>
                                                {option}
                                            </option>
                                        ))}
                                    </select>
                                </div>
                                {
                                    pageNumbers
                                        .filter((pageNumber) => (
                                            pageNumber <= page + 3 && pageNumber >= page - 2
                                        ))
                                        .map((pageNumber) => (
                                            <button styleName={`page-button ${pageNumber === page ? 'active' : ''}`}
                                                key={pageNumber}
                                                onClick={() => handlePageClick(pageNumber)}
                                            >
                                                {pageNumber}
                                            </button>
                                        ))
                                }
                            </div>}
                        </div>
                        <div styleName='log-details-container'>
                            {logDetails()}
                        </div>
                    </div>
                </MainView.Content>
            </MainView.Container>
        )
    }
}



// WEBPACK FOOTER //
// ./src/modules/products/EditProductView/StepIntegrations/StepIntegrations.jsx